module.exports = __webpack_public_path__ + "img/chinesecompany178.ec29336f.png";